import { render, staticRenderFns } from "./RestorePasswordRequest.vue?vue&type=template&id=67e524d8&scoped=true&lang=pug&"
import script from "./RestorePasswordRequest.vue?vue&type=script&lang=js&"
export * from "./RestorePasswordRequest.vue?vue&type=script&lang=js&"
import style0 from "./RestorePasswordRequest.vue?vue&type=style&index=0&id=67e524d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e524d8",
  null
  
)

component.options.__file = "RestorePasswordRequest.vue"
export default component.exports